<template>
  <div class="qd-apply flex-v-ac">
    <KaihuForm ref="apply" :view-data="viewData" @change="handleFormChange">
      <template v-slot:chooseType>
        <el-form style="margin-left: 190px" :label-position="'left'">
          <el-form-item label="申请账号数" class="m-t20 flex-h">
            <el-input-number
              style="margin-left: 29px; width: 120px"
              v-model="haveQdAccount"
              size="medium"
              :min="1"
              :max="999"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="申请开通周期" v-if="!isFree" class="m-t20 flex-h">
            <el-radio-group v-model="cycle" size="medium" class="m-l30" style="width: 300px">
              <el-radio-button
                v-for="(v, i) in ['1年', '2年', '3年']"
                :key="i"
                :label="v"
              ></el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="价格" class="relative-view">
            <div
              class="f-16"
              :class="[isFree ? 'c-9' : '']"
              :style="{ 'text-decoration': isFree ? 'line-through' : 'none' }"
            >
              <span class="f-b f-24" :class="[isFree ? '' : 'c-red']" style="margin-left: 30px">{{
                price | formatMoneyCent
              }}</span>
              元
            </div>
            <div v-if="isFree" class="temp f-9 c-f">免费至2020-6-30</div>
          </el-form-item>
        </el-form>
      </template>
      <!-- <template v-slot:downloadContract>
        <div class="c-3 f-9 m-t15">
          请先<a class="download" @click="downloadContract">下载合同模板 </a
          ><span class="c-9 m-l5"> 请上传小于2M的图片（支持jpg、png、bmp格式）</span>
        </div>
      </template> -->
      <template v-slot:downloadAttorney>
        <div class="c-3 f-9 m-t15">
          请先<a class="download m-t10" @click="downloadAttorney">下载委托函模板</a
          ><span class="c-9 m-l5"> 请上传小于2M的图片（支持jpg、png、bmp格式）</span>
        </div>
      </template>
      <template v-slot:tipBank>
        <div class="c-3 f-12 f-b">注：腾讯将对公账户信息进行打款认证。</div>
      </template>
    </KaihuForm>
    <!-- 按钮 -->
    <div class="m-t50">
      <!-- <el-button class="m-r50" @click="goBackPage">取 消</el-button> -->
      <el-button :disabled="!is" type="primary" @click="handleFormSubmit">提 交</el-button>
    </div>
  </div>
</template>

<script>
import { KaihuForm } from 'zgkaihu'
import { fileUrlAdapter } from '../../common/filters'

export default {
  name: 'qd-apply',
  components: { KaihuForm },
  data() {
    return {
      fileUrlAdapter,
      is: false, // 是否可提交
      isFree: true, // 账号免费到6月底
      haveQdAccount: 1,
      cycle: '1年',
      isEmailDone: false, // 用于判断是否手动输入过邮箱
      viewData: [
        { type: 'title', title: '选择套餐' },
        { type: 'slot', key: 'chooseType' },
        { type: 'title', title: '公司信息' },
        {
          type: 'input',
          key: 'orgRealName',
          label: '企业名称',
          defaultValue: '',
          placeholder: '',
          disabled: true
        },
        {
          type: 'file',
          accept: 'image/jpg, image/jpeg, image/png',
          maxSize: 2097152,
          data: [{ key: 'businessLicence', label: '营业执照', required: true }]
        },
        {
          type: 'file',
          accept: 'image/jpg, image/jpeg, image/png',
          maxSize: 2097152,
          data: [
            { key: 'contractFrontImg', label: '合同正面', required: true },
            { key: 'contractBackImg', label: '合同背面', required: true }
          ]
        },
        { type: 'slot', key: 'downloadContract' },
        { type: 'title', title: '联系人信息' },
        {
          type: 'input',
          key: 'agent',
          label: '管理员姓名',
          defaultValue: '',
          placeholder: '请输入',
          rules: { required: true, message: `请输入联系人姓名`, trigger: 'change' }
        },
        {
          type: 'input',
          key: 'agentPhone',
          label: '管理员电话',
          defaultValue: '',
          placeholder: '请输入',
          rules: {
            required: true,
            message: `请输入正确的联系人电话`,
            pattern: /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/,
            trigger: 'change'
          }
        },
        {
          type: 'input',
          key: 'qqAccount',
          label: '管理员QQ',
          defaultValue: '',
          placeholder: '请输入',
          rules: {
            required: true,
            message: `请输入正确的联系人QQ`,
            pattern: /^\d+$/,
            trigger: 'change'
          }
        },
        {
          type: 'input',
          key: 'email',
          label: '管理员邮箱',
          defaultValue: '',
          placeholder: '请输入',
          rules: {
            required: true,
            message: `请输入正确的联系人邮箱`,
            pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
            trigger: 'change'
          }
        },
        {
          type: 'file',
          accept: 'image/jpg, image/jpeg, image/png',
          maxSize: 2097152,
          data: [
            { key: 'agentIdentityCardA', label: '法人身份证正面', required: true },
            { key: 'agentIdentityCardB', label: '法人身份证背面', required: true }
          ]
        },
        {
          type: 'file',
          accept: 'image/jpg, image/jpeg, image/png',
          maxSize: 2097152,
          data: [
            {
              key: 'handheldIdentityUrl',
              label: '法人手持身份证照片',
              required: true,
              desc: '管理员非法人时请上传管理员手持法人身份证照片',
              descSingle: true
            }
          ]
        },
        {
          type: 'file',
          accept: 'image/jpg, image/jpeg, image/png',
          maxSize: 2097152,
          data: [
            {
              key: 'powerOfAttorney',
              label: '委托函',
              desc: '管理员非法人时请上传委托函',
              descSingle: true,
              required: false
            }
          ]
        },
        { type: 'slot', key: 'downloadAttorney' },
        { type: 'title', title: '银行信息' },
        {
          type: 'input',
          key: 'openBankNo',
          label: '对公账号开户行',
          maxlength: 20,
          defaultValue: '',
          placeholder: '请输入',
          rules: { required: true, message: `请输入对公账号开户行`, trigger: 'change' }
        },
        {
          type: 'input',
          key: 'openBank',
          label: '对公账户名称',
          maxlength: 20,
          defaultValue: '',
          placeholder: '请输入',
          rules: { required: true, message: `请输入对公账户名称`, trigger: 'change' }
        },
        {
          type: 'input',
          key: 'bankNo',
          label: '对公账号',
          maxlength: 30,
          defaultValue: '',
          placeholder: '请输入',
          rules: { required: true, message: `请输入对公账号`, pattern: /^\d+$/, trigger: 'change' }
        },
        { type: 'slot', key: 'tipBank' }
      ]
    }
  },
  computed: {
    userCurrentOrg() {
      return this.$store.getters.userCurrentOrg
    },
    price() {
      return 200000 * this.cycle.replace('年', '') * this.haveQdAccount
    }
  },
  async mounted() {
    await this.getInitData()
    this.$refs.apply.setModel('orgRealName', this.userCurrentOrg.name)
  },
  methods: {
    async getInitData() {
      const { success, data } = await this.$get('organization.queryAuthLatestMsg')
      if (success && data[0].orgAuditResultList && data[0].orgAuditResultList.length > 0) {
        try {
          data[0].orgAuditResultList.forEach(orgAuditResult => {
            if (
              orgAuditResult.orgAuditExtResult &&
              orgAuditResult.orgAuditExtResult.signType == 1 &&
              (orgAuditResult.orgAuditExtResult.auditType == 10 ||
                orgAuditResult.orgAuditExtResult.auditType == 13)
            ) {
              // 填充开户行内容
              this.$refs.apply.setModel('openBankNo', orgAuditResult.orgAuditExtResult.openBank)
              this.$refs.apply.setModel('openBank', this.userCurrentOrg.name)
              this.$refs.apply.setModel('bankNo', orgAuditResult.orgAuditExtResult.bankNo)
              // 填充营业执照相关的内容
              this.viewData.forEach(data => {
                if (data.data) this.assignmentFile(data.data, orgAuditResult)
              })
              // console.log('~~~~1~~~~~`', orgAuditResult, this.$refs.apply.getData())
              throw 'jumpout'
            }
          })
        } catch (e) {
          console.log('')
        }
      }
    },
    assignmentFile(data, res) {
      data.forEach(ele => {
        let fk = ''
        if (ele.key == 'agentIdentityCardA') {
          fk = res['identityCardA']
        } else if (ele.key == 'agentIdentityCardB') {
          fk = res['identityCardB']
        } else {
          fk = res[ele.key]
        }
        let url = this.fileUrlAdapter(fk)
        this.$set(ele, 'fk', fk)
        this.$set(ele, 'url', url)
      })
    },
    handleFormChange({ key, value }) {
      this.is = this.$refs.apply.submitted()
      // 仅改变email组件
      if (key === 'email') {
        // 用户输入过邮箱
        this.isEmailDone = !!value
      }
      if (key === 'qqAccount') {
        // 输入QQ号, 自动填充邮箱
        if (!this.isEmailDone) {
          this.$refs.apply.model.email = value + '@qq.com'
        }
        // QQ号清空或输入有误, 清空邮箱
        if (this.$refs.apply.model.qqAccount == '' && !this.isEmailDone) {
          this.$refs.apply.model.email = ''
        }
      }
    },
    async handleFormSubmit() {
      let form = this.$refs.apply.getData()
      let submitAuthParam = {
        auditType: 14, // 企点账户申请类型: 14
        signType: 1, // 签约类型: 1
        price: this.price * this.isFree ? 0 : 1,
        haveQdAccount: this.haveQdAccount,
        cycle: Number(this.cycle.replace('年', '')),
        ...form
      }
      console.log('~~~~~~~~~~~~~', submitAuthParam)
      const { success, data } = await this.$post('organization.submitAuth', {
        submitAuthParam: submitAuthParam
      })
      if (success && data[0].success) {
        this.$message.success('认证信息已提交, 待审核')
        this.goBackPage()
      } else {
        this.$message.error(data[0].errorMessage)
      }
    },
    goBackPage() {
      this.$store.commit('tagsView/DEL_VISITED_VIEW', { path: this.$route.path })
      window.history.back()
    },
    // 下载逻辑
    downloadContract() {
      let url =
        'https://shadow.zhaogangimg.com/assets/pm-hawk/V1-模板-企点行业版-B2B行业用户合同模板.pdf'
      window.open(url)
    },
    downloadAttorney() {
      let url = 'https://shadow.zhaogangimg.com/assets/pm-hawk/V1-模板-企点业务办理委托函.pdf'
      window.open(url)
    },
    download(url, name) {
      try {
        let downloadElement = document.createElement('a')
        downloadElement.download = name
        downloadElement.href = url
        document.body.appendChild(downloadElement)
        downloadElement.click()
        document.body.removeChild(downloadElement)
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style lang="less">
.qd-apply {
  .el-form-item {
    width: 510px;
  }
  .el-form-item__label {
    width: 100px;
  }
  .el-form-item__content {
    display: flex;
    width: 300px;
  }
}
</style>

<style lang="less" scoped>
.qd-apply {
  .download {
    color: #cd974c;
    &:hover {
      color: #efb96f;
    }
  }
  .temp {
    width: 100px;
    height: 20px;
    background: linear-gradient(283deg, rgba(240, 36, 46, 1) 0%, rgba(208, 17, 26, 1) 100%);
    border-radius: 1px;
    line-height: 20px;
    text-align: center;
    position: absolute;
    top: 42px;
    left: 28px;
  }
}
</style>
